import React from "react";
import { Container } from "react-bootstrap";
import InnerBanner from "../../Components/InnerBanner";
import { Loader } from "../../Components/Loader";
import { CONFLICT_OF_INTEREST_POLICY } from "../../services/Url";
import { useCustomGet } from "../../services/Service";

export const ConflictofInterestPolicy = () => {
  const { data, isLoading } = useCustomGet(CONFLICT_OF_INTEREST_POLICY)

  var bannerContent = {
    cardTitle: data?.cip_banner_heading,
    cardPara: "",
  }

  return (
    <>
     {
        isLoading ? 
        <Loader /> :''
      }
      <InnerBanner bannerCnt={bannerContent} banImg={data?.cip_banner_image} />
      <div className="internal-service-page" id="cyber-essen-certi-service">
        <Container>
        <div className="privacy custom-list sec-padding"
            dangerouslySetInnerHTML={{__html: data?.cip_content}}
        >
        </div>
        </Container>
      </div>
    </>
  );
};
